module.exports = __webpack_public_path__ + "static/media/steamedtwigs.00ed9562.png";